import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
// import { useAuthStore } from '../stores/auth'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ZoomOutGameView from '../views/ZoomOutGameView.vue'
import ResolutionGameView from '../views/ResolutionGameView.vue'
import NoiseGameView from '../views/NoiseGameView.vue'
import MultiplayerGameView from '../views/MultiplayerGameView.vue'
import RoomListView from '../views/RoomListView.vue'
import RoomCreateView from '../views/RoomCreateView.vue'
import RoomDetailView from '../views/RoomDetailView.vue'
import SettingsView from '../views/SettingsView.vue'
import SinglePlaySelectionView from '../views/SinglePlaySelectionView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import AboutView from '../views/AboutView.vue';
import ContactView from '../views/ContactView.vue';


const router = createRouter({
  history: import.meta.env.MODE === 'itch'
    // Itch.io（iframe/静的ホスティング）では、Webサーバー側のルーティング設定（すべてのパスでindex.htmlを返す設定）ができないため、
    // URLのハッシュ（#）を使ってルーティングを制御する HashHistory モードを使用します。
    // これにより、404エラーを防ぎ、ページ遷移を正常に行えます。
    ? createWebHashHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeView
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginView
    },
    {
      path: '/single-play',
      name: 'SinglePlaySelection',
      component: SinglePlaySelectionView
    },
    {
      path: '/game/zoom-out',
      name: 'ZoomOutGame',
      component: ZoomOutGameView,
      meta: { requiresAuth: true }
    },
    {
      path: '/game/resolution',
      name: 'ResolutionGame',
      component: ResolutionGameView,
      meta: { requiresAuth: true }
    },
    {
      path: '/game/noise',
      name: 'NoiseGame',
      component: NoiseGameView,
      meta: { requiresAuth: true }
    },
    {
      path: '/game/mix',
      name: 'MixGame',
      component: () => import('../views/MixGameView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/game/multiplayer/:roomId',
      name: 'MultiplayerGame',
      component: MultiplayerGameView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/rooms',
      name: 'RoomList',
      component: RoomListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/rooms/create',
      name: 'RoomCreate',
      component: RoomCreateView,
      meta: { requiresAuth: true }
    },
    {
      path: '/rooms/:roomId',
      name: 'RoomDetail',
      component: RoomDetailView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: SettingsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicyView
    },
    {
      path: '/about',
      name: 'About',
      component: AboutView
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactView
    },
    {
      path: '/tech/image-processing',
      name: 'ImageProcessingDoc',
      component: () => import('../views/tech/ImageProcessingDoc.vue')
    },
    {
      path: '/tech/unsplash-integration',
      name: 'UnsplashIntegrationDoc',
      component: () => import('../views/tech/UnsplashIntegrationDoc.vue')
    }
  ]
})

// ログイン機能を無効化するため、ガードをコメントアウトしました
// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore()
//   if (to.meta.requiresAuth && !authStore.isAuthenticated) {
//     next({ name: 'Login' })
//   } else {
//     next()
//   }
// })

export default router
